import React from 'react';
import { sweetalert } from '../../App';
import Overlay from '../Overlay';
import { buildRow, getLabel, hideModal, showModalNoOutsideClick } from '../../util/FormatUtil';
import { AuthNetEnvironment, HostedForm } from 'react-acceptjs';
import { isBlank, isOnlyWhitespace, isValidEmail } from '../../util/ValidationUtil';
import Select from 'react-select';
import { FacilityAPI } from '../../network/FacilityAPI';
import DiscountAPI from '../../network/DiscountAPI';
import PaymentAPI from '../../network/PaymentAPI';
import ShopAPI from '../../network/ShopAPI';
import AutoComplete from '../../util/AutoComplete';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';

interface HomeKitPaymentFormModalProps {
  handleProductPaymentInfo?: (email, response, totalPayment, taxes, addressObjForShop, lineItems) => void;
  selectedFacility?;
  refreshSelectedFacility?;
  countries;
  states;
  cartTotal?: number;
  cart?;
}

interface HomeKitPaymentFormModalState {
  showLoading: boolean;
  totalAmountForServices;
  showPaymentProfileInfo?: boolean;
  paymentAmount;
  ANETCustomerProfile?;
  hostedFormResponse?;
  paymentObject?;
  lineItems?;
  changesMade?: boolean;
  billToInfoVerified?: boolean;
  selectedFacility?;
  cart?;
  cartTotal?;
  taxAmount?;
  paymentIndexSelected: number;
  addressObjForShop?;
  shopValidated?: boolean;
  useManualAddress: boolean;
}

const authData = {
  apiLoginID: process.env.REACT_APP_AUTHORIZE_NET_LOGIN_ID,
  clientKey: process.env.REACT_APP_AUTHORIZE_NET_PUBLIC_CLIENT_KEY,
};
const aNetEnv = process.env.REACT_APP_AUTHORIZE_NET_ENVIRONMENT as AuthNetEnvironment;

export class HomeKitPaymentFormModal extends React.Component<
  HomeKitPaymentFormModalProps,
  HomeKitPaymentFormModalState
> {
  public static ID = 'homekitpaymentForm';

  constructor(props) {
    super(props);
    this.state = {
      showLoading: false,
      totalAmountForServices: null,
      paymentAmount: null,
      ANETCustomerProfile: null,
      hostedFormResponse: null,
      paymentObject: null,
      lineItems: null,
      changesMade: false,
      billToInfoVerified: false,
      selectedFacility: {},
      taxAmount: 0,
      paymentIndexSelected: 0,
      shopValidated: true,
      useManualAddress: false,
    };
    this.clearPaymentFormState = this.clearPaymentFormState.bind(this);
  }

  clearPaymentFormState = () => {
    return this.setState({
      totalAmountForServices: 0,
      paymentAmount: '',
      ANETCustomerProfile: null,
      hostedFormResponse: null,
      paymentObject: null,
      lineItems: null,
      changesMade: false,
      billToInfoVerified: false,
      selectedFacility: {},
      paymentIndexSelected: 0,
      addressObjForShop: null,
    });
  };

  handleAutoCompleteUpdate = (
    streetAddress: string,
    city: string,
    state: string,
    postalCode: string,
    county: string,
    country: string
  ) => {
    this.setState((prevState) => ({
      addressObjForShop: {
        ...prevState.addressObjForShop,
        address: streetAddress,
        city: city,
        state: state,
        zip: postalCode,
        country: country,
      },
    }));
  };

  loadScript(src: string) {
    var tag = document.createElement('script');
    tag.src = src;
    document.body.appendChild(tag);
  }

  componentDidMount(): void {
    $(`#${HomeKitPaymentFormModal.ID}`).on('shown.bs.modal', function () {
      $(document).off('focusin.modal');
    });
    this.loadScript(process.env.REACT_APP_AUTHORIZE_NET_LOADSCRIPT);
  }

  UNSAFE_componentWillReceiveProps(nextProps: Readonly<HomeKitPaymentFormModalProps>, nextContext: any): void {
    // console.log('HomeKitPaymentFormModal componentWillReceiveProps nextProps', nextProps);
    // if (nextProps !== this.props) { }
    // nextProps is maybe what is causing the issue with totals showing as zero when modal is closed and reopened
    this.setState(
      {
        cart: nextProps.cart ? nextProps.cart : [],
        cartTotal: nextProps.cartTotal ? nextProps.cartTotal : 0,
        selectedFacility: nextProps.selectedFacility ? nextProps.selectedFacility : null,
      },
      () => {
        if (
          this.state.selectedFacility &&
          !isOnlyWhitespace(this.state.selectedFacility?.ANETCustomerProfileID) &&
          !isBlank(this.state.selectedFacility?.ANETCustomerProfileID) &&
          !isOnlyWhitespace(this.state.selectedFacility?.ANETCustomerPaymentProfileID) &&
          !isBlank(this.state.selectedFacility.ANETCustomerPaymentProfileID)
        ) {
          PaymentAPI.getCustomerProfile(
            this.state.selectedFacility.ANETCustomerProfileID,
            this.state.selectedFacility.ANETCustomerPaymentProfileID
          ).then((data) => {
            this.setState({ ANETCustomerProfile: data.customerProfile.profile }, () => {
              $('#flexRadio0').prop('checked', true).trigger('click');
            });
          });
        } else {
          this.setState({
            ANETCustomerProfile: {
              customerProfileId: '',
              description: '',
              email: '',
              paymentProfiles: [
                {
                  billTo: {
                    address: '',
                    city: '',
                    country: '',
                    firstName: '',
                    lastName: '',
                    phoneNumber: '',
                    state: '',
                    zip: '',
                  },
                  customerPaymentProfileId: '',
                  payment: {
                    creditCard: {
                      cardNumber: '',
                      cardType: '',
                      expirationDate: '',
                    },
                  },
                },
              ],
              profileType: 'regular',
              // shipToList: [
              //     {
              //         address: '',
              //         city: '',
              //         company: '',
              //         country: '',
              //         customerAddressId: '',
              //         faxNumber: '',
              //         firstName: '',
              //         lastName: '',
              //         phoneNumber: '',
              //         state: '',
              //         zip: ''
              //     }
              // ]
            },
            selectedFacility: nextProps.selectedFacility,
          });
        }
      }
    );
    // }
  }

  buildLineItems = () => {
    if (this.state.cart && this.state.cart.length > 0) {
      let productLineItems = JSON.parse(JSON.stringify(this.state.cart));
      return productLineItems;
    }
  };

  handleHostedFormResponse = async (hostedFormResponse) => {
    // console.log("hostedFormResponse", hostedFormResponse);
    this.setState({ hostedFormResponse: hostedFormResponse, paymentObject: hostedFormResponse }, () => {
      $('#flexRadioEntered').prop('checked', true).trigger('click');
    });
  };

  displayPaymentProfileOptions() {
    if (this.state.ANETCustomerProfile === null) {
      return;
    }
    let paymentOptions = this.state.ANETCustomerProfile?.paymentProfiles;
    let cardOnFile =
      paymentOptions &&
      paymentOptions.length &&
      paymentOptions.length > 0 &&
      paymentOptions[0].customerPaymentProfileId !== '';
    return (
      <div className="" id="profile_payment_options">
        {!cardOnFile &&
          this.state.hostedFormResponse !== null &&
          this.state.ANETCustomerProfile?.customerProfileId === '' && (
            <div className="col-sm-12">
              <div className={'form-group row'}>
                <div className={'col-12 pr-0'} data-toggle={'tooltip'} data-placement={'top'} title={'SaveCard'}>
                  <div className="form-check float-right" style={{ paddingTop: '0.25rem' }}>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={this.state.showPaymentProfileInfo ? true : false}
                      id="saveCardInfoCheck"
                      onChange={() => this.setState({ showPaymentProfileInfo: !this.state.showPaymentProfileInfo })}
                    />
                    <label className="form-check-label" htmlFor="saveCardInfoCheck">
                      Save Card Information
                    </label>
                  </div>
                </div>
              </div>
            </div>
          )}
        {cardOnFile && (
          <div className="col-sm-12">
            <div className={''}>Card On File:</div>
            {paymentOptions.map((pt, ndx) => {
              return (
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name={'flexRadioGroup'}
                    id={'flexRadio' + ndx}
                    onClick={() => {
                      this.setState({
                        paymentObject: this.state.ANETCustomerProfile,
                        paymentIndexSelected: ndx,
                        shopValidated: true,
                      });
                    }}
                  />
                  <label className="form-check-label" htmlFor={'flexRadio' + ndx}>
                    {pt.payment.creditCard.cardNumber}
                  </label>
                </div>
              );
            })}
            {this.state.hostedFormResponse !== null && !cardOnFile && (
              <div className="" id="profile_entered_payment_options">
                <div className={''}>Entered:</div>
                <div className={'form-check'}>
                  <input
                    className={'form-check-input'}
                    type="radio"
                    name={'flexRadioGroup'}
                    id={'flexRadioEntered'}
                    onClick={() => {
                      this.setState({ paymentObject: this.state.hostedFormResponse });
                    }}
                  />
                  <label className={'form-check-label'} htmlFor={'flexRadioEntered'}>
                    {this.state.hostedFormResponse?.encryptedCardData.cardNumber}
                  </label>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  verifyBillToInfo() {
    if (
      isBlank(this.state.ANETCustomerProfile.paymentProfiles[0].billTo.firstName) ||
      isOnlyWhitespace(this.state.ANETCustomerProfile.paymentProfiles[0].billTo.firstName)
    ) {
      return sweetalert.fire({ icon: 'error', title: '', text: 'First Name is required' });
    }
    if (
      isBlank(this.state.ANETCustomerProfile.paymentProfiles[0].billTo.lastName) ||
      isOnlyWhitespace(this.state.ANETCustomerProfile.paymentProfiles[0].billTo.lastName)
    ) {
      return sweetalert.fire({ icon: 'error', title: '', text: 'Last Name is required' });
    }
    if (
      isBlank(this.state.ANETCustomerProfile.email) ||
      isOnlyWhitespace(this.state.ANETCustomerProfile.email) ||
      !isValidEmail(this.state.ANETCustomerProfile.email)
    ) {
      return sweetalert.fire({ icon: 'error', title: '', text: 'Email is required and must be valid' });
    }
    if (
      isBlank(this.state.ANETCustomerProfile.paymentProfiles[0].billTo.phoneNumber) ||
      isOnlyWhitespace(this.state.ANETCustomerProfile.paymentProfiles[0].billTo.phoneNumber) ||
      !isValidPhoneNumber(this.state.ANETCustomerProfile.paymentProfiles[0].billTo.phoneNumber)
    ) {
      return sweetalert.fire({ icon: 'error', title: '', text: 'Phone number is required and must be valid' });
    }
    if (
      isBlank(this.state.ANETCustomerProfile.paymentProfiles[0].billTo.address) ||
      isOnlyWhitespace(this.state.ANETCustomerProfile.paymentProfiles[0].billTo.address)
    ) {
      return sweetalert.fire({ icon: 'error', title: '', text: 'Address is required' });
    }
    if (
      isBlank(this.state.ANETCustomerProfile.paymentProfiles[0].billTo.city) ||
      isOnlyWhitespace(this.state.ANETCustomerProfile.paymentProfiles[0].billTo.city)
    ) {
      return sweetalert.fire({ icon: 'error', title: '', text: 'City is required' });
    }
    if (
      isBlank(this.state.ANETCustomerProfile.paymentProfiles[0].billTo.state) ||
      isOnlyWhitespace(this.state.ANETCustomerProfile.paymentProfiles[0].billTo.state)
    ) {
      return sweetalert.fire({ icon: 'error', title: '', text: 'State is required' });
    }
    if (
      isBlank(this.state.ANETCustomerProfile.paymentProfiles[0].billTo.country) ||
      isOnlyWhitespace(this.state.ANETCustomerProfile.paymentProfiles[0].billTo.country)
    ) {
      return sweetalert.fire({ icon: 'error', title: '', text: 'Country is required' });
    }
    if (
      isBlank(this.state.ANETCustomerProfile.paymentProfiles[0].billTo.zip) ||
      isOnlyWhitespace(this.state.ANETCustomerProfile.paymentProfiles[0].billTo.zip) ||
      !/^\d{5}(-\d{4})?(?!-)$/.test(this.state.ANETCustomerProfile.paymentProfiles[0].billTo.zip)
    ) {
      return sweetalert.fire({ icon: 'error', title: '', text: 'Zipcode is required and must be valid' });
    }
    sweetalert.fire({ icon: 'success', title: '', text: 'Bill To Info Successfully Validated' });

    this.setState({ billToInfoVerified: true }, () => {
      this.handleBillToSubmit(this.state.hostedFormResponse);
      // clear out hostedFormResponse to prevent Invalid OTS Token error
      // we will use card on profile to make payment
      this.setState({ hostedFormResponse: null }, () => {
        $('#flexRadio0').prop('checked', true).trigger('click');
      });
      //set new card to be used as payment
    });
  }

  updateBillToInfoOnly() {
    this.setState({ showLoading: true }, async () => {
      PaymentAPI.updateCustomerProfileWithoutCardInfo(
        this.state.selectedFacility.ANETMerchantID,
        this.state.selectedFacility.ANETCustomerProfileID,
        this.state.selectedFacility.ANETCustomerPaymentProfileID,
        this.state.ANETCustomerProfile
      ).then((updatedResponse) => {
        if (!updatedResponse.success) {
          this.setState({ showLoading: false });
          return sweetalert.fire({
            icon: 'error',
            title: '',
            text: 'Error updating Bill To Profile. Please submit form and try again.',
          });
        } else {
          this.setState({
            changesMade: true,
            ANETCustomerProfile: updatedResponse.updatedCustomerProfile.profile,
            showLoading: false,
          });
          return sweetalert.fire({
            icon: 'success',
            title: '',
            text: 'Bill To Profile updated successfully',
          });
        }
      });
    });
  }

  async handleBillToSubmit(response) {
    let description = `${this.state.selectedFacility.ProviderFirstName}-${this.state.selectedFacility.ProviderLastName}-${this.state.selectedFacility.FacilityName}`;
    this.setState({ showLoading: true }, async () => {
      if (this.state.selectedFacility.ANETCustomerProfileID) {
        this.updateBillToInfoOnly();
      } else {
        await PaymentAPI.createCustomerProfile(this.state.ANETCustomerProfile, description, response).then(
          (createResponse) => {
            this.setState({ showLoading: false });
            if (!createResponse.success) {
              return sweetalert.fire({
                icon: 'error',
                title: '',
                text: 'Error creating Bill To Profile. Please try again.',
              });
            } else {
              try {
                FacilityAPI.addANetCustomerProfileIDs({
                  facilityID: this.state.selectedFacility.ID,
                  aNetIDs: {
                    merchantID: createResponse.createdCustomerProfile.profile.merchantCustomerId,
                    customerProfileID: createResponse.createdCustomerProfile.profile.customerProfileId,
                    paymentProfileID:
                      createResponse.createdCustomerProfile.profile.paymentProfiles[0].customerPaymentProfileId,
                  },
                }).then((result) => {
                  this.setState({
                    changesMade: true,
                    ANETCustomerProfile: createResponse.createdCustomerProfile.profile,
                    selectedFacility: result.data,
                  });
                  this.props.refreshSelectedFacility();
                  return sweetalert.fire({ icon: 'success', title: '', text: 'Bill To Profile created successfully' });
                });
              } catch (e) {
                console.error(e);
                return sweetalert.fire({
                  icon: 'error',
                  title: '',
                  text: 'Error updating Facility with ANet Profile.',
                });
              }
            }
          }
        );
      }
    });
  }

  clearProfileState() {
    this.setState({
      billToInfoVerified: false,
      changesMade: false,
      ANETCustomerProfile: {
        customerProfileId: '',
        description: '',
        email: '',
        paymentProfiles: [
          {
            billTo: {
              address: '',
              city: '',
              country: '',
              firstName: '',
              lastName: '',
              phoneNumber: '',
              state: '',
              zip: '',
            },
            customerPaymentProfileId: '',
            payment: {
              creditCard: {
                cardNumber: '',
                cardType: '',
                expirationDate: '',
              },
            },
          },
        ],
        profileType: 'regular',
        shipToList: [
          {
            address: '',
            city: '',
            company: '',
            country: '',
            customerAddressId: '',
            faxNumber: '',
            firstName: '',
            lastName: '',
            phoneNumber: '',
            state: '',
            zip: '',
          },
        ],
      },
    });
  }

  toggleAddressMode = () => {
    this.setState({ useManualAddress: !this.state.useManualAddress });
  };

  getFormattedAddressForAutocomplete = () => {
    const addr = this.state.addressObjForShop;
    if (!addr) return '';
    const parts = [addr.address, addr.city, addr.state, addr.zip].filter(Boolean);
    return parts.length > 1 ? parts.join(', ') : addr.address || '';
  };

  getShippingAddressForShop = () => {
    // AutoComplete mode: just address field + email
    if (!this.state.useManualAddress) {
      return (
        <div>
          <div className="row">
            <div className="col-12">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">First Name</label>
                <div className="col-sm-9">
                  <input
                    className={'form-control'}
                    autoComplete={'off'}
                    type={'text'}
                    name={`FirstName`}
                    onChange={(e) => {
                      this.setState((prevState) => ({
                        addressObjForShop: {
                          ...prevState.addressObjForShop,
                          firstName: e.target.value,
                        },
                      }));
                    }}
                    value={this.state.addressObjForShop?.firstName || ''}
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Last Name</label>
                <div className="col-sm-9">
                  <input
                    className={'form-control'}
                    autoComplete={'off'}
                    type={'text'}
                    name={`LastName`}
                    onChange={(e) => {
                      this.setState((prevState) => ({
                        addressObjForShop: {
                          ...prevState.addressObjForShop,
                          lastName: e.target.value,
                        },
                      }));
                    }}
                    value={this.state.addressObjForShop?.lastName || ''}
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Facility Email</label>
                <div className="col-sm-9">
                  <input
                    className={'form-control'}
                    autoComplete={'off'}
                    type={'email'}
                    name={`Email`}
                    onChange={(e) => {
                      this.setState((prevState) => ({
                        addressObjForShop: {
                          ...prevState.addressObjForShop,
                          email: e.target.value,
                        },
                      }));
                    }}
                    value={this.state.addressObjForShop?.email || ''}
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Phone</label>
                <div className="col-sm-9">
                  <PhoneInput
                    placeholder="Enter phone number"
                    value={this.state.addressObjForShop?.phoneNumber || ''}
                    onChange={(value) => {
                      this.setState((prevState) => ({
                        addressObjForShop: {
                          ...prevState.addressObjForShop,
                          phoneNumber: value,
                        },
                      }));
                    }}
                    defaultCountry="US"
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Address</label>
                <div className="col-sm-7">
                  <AutoComplete
                    id="shippingAddressAutocomplete"
                    value={this.getFormattedAddressForAutocomplete()}
                    placeholder="123 Main Street..."
                    onChange={(value) => {
                      this.setState((prevState) => ({
                        addressObjForShop: {
                          ...prevState.addressObjForShop,
                          address: value,
                        },
                      }));
                    }}
                    updateFormData={this.handleAutoCompleteUpdate}
                  />
                </div>
                <div className="col-sm-2 d-flex align-items-center">
                  <span
                    style={{ cursor: 'pointer', fontSize: '0.85rem', color: '#007bff' }}
                    onClick={this.toggleAddressMode}
                  >
                    Enter Manually
                  </span>
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Notes</label>
                <div className="col-sm-9">
                  <textarea
                    className={'form-control'}
                    rows={3}
                    name={`Notes`}
                    placeholder="Optional notes..."
                    onChange={(e) => {
                      this.setState((prevState) => ({
                        addressObjForShop: {
                          ...prevState.addressObjForShop,
                          notes: e.target.value,
                        },
                      }));
                    }}
                    value={this.state.addressObjForShop?.notes || ''}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    // Manual mode: all individual fields
    return (
      <div>
        <div className="row">
          <div className="col-12">
            <div className="form-group row">
              <label className="col-sm-3 col-form-label">First Name</label>
              <div className="col-sm-9">
                <input
                  className={'form-control'}
                  autoComplete={'off'}
                  type={'text'}
                  name={`FirstName`}
                  onChange={(e) => {
                    this.setState((prevState) => ({
                      addressObjForShop: {
                        ...prevState.addressObjForShop,
                        firstName: e.target.value,
                      },
                    }));
                  }}
                  value={this.state.addressObjForShop?.firstName || ''}
                />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-sm-3 col-form-label">Last Name</label>
              <div className="col-sm-9">
                <input
                  className={'form-control'}
                  autoComplete={'off'}
                  type={'text'}
                  name={`LastName`}
                  onChange={(e) => {
                    this.setState((prevState) => ({
                      addressObjForShop: {
                        ...prevState.addressObjForShop,
                        lastName: e.target.value,
                      },
                    }));
                  }}
                  value={this.state.addressObjForShop?.lastName || ''}
                />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-sm-3 col-form-label">Email</label>
              <div className="col-sm-9">
                <input
                  className={'form-control'}
                  autoComplete={'off'}
                  type={'email'}
                  name={`Email`}
                  onChange={(e) => {
                    this.setState((prevState) => ({
                      addressObjForShop: {
                        ...prevState.addressObjForShop,
                        email: e.target.value,
                      },
                    }));
                  }}
                  value={this.state.addressObjForShop?.email || ''}
                />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-sm-3 col-form-label">Phone</label>
              <div className="col-sm-9">
                <PhoneInput
                  placeholder="Enter phone number"
                  value={this.state.addressObjForShop?.phoneNumber || ''}
                  onChange={(value) => {
                    this.setState((prevState) => ({
                      addressObjForShop: {
                        ...prevState.addressObjForShop,
                        phoneNumber: value,
                      },
                    }));
                  }}
                  defaultCountry="US"
                />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-sm-3 col-form-label">Address</label>
              <div className="col-sm-7">
                <input
                  className={'form-control'}
                  autoComplete={'off'}
                  type={'text'}
                  name={`BillToAddress`}
                  placeholder="123 Main Street..."
                  onChange={(e) => {
                    this.setState((prevState) => ({
                      addressObjForShop: {
                        ...prevState.addressObjForShop,
                        address: e.target.value,
                      },
                    }));
                  }}
                  value={this.state.addressObjForShop?.address || ''}
                />
              </div>
              <div className="col-sm-2 d-flex align-items-center">
                <span
                  style={{ cursor: 'pointer', fontSize: '0.85rem', color: '#007bff' }}
                  onClick={this.toggleAddressMode}
                >
                  Search Address
                </span>
              </div>
            </div>

            <div className="form-group row">
              <label className="col-sm-3 col-form-label">City</label>
              <div className="col-sm-9">
                <input
                  className={'form-control'}
                  autoComplete={'off'}
                  type={'text'}
                  name={`BillToCity`}
                  onChange={(e) => {
                    this.setState((prevState) => ({
                      addressObjForShop: {
                        ...prevState.addressObjForShop,
                        city: e.target.value,
                      },
                    }));
                  }}
                  value={this.state.addressObjForShop?.city || ''}
                />
              </div>
            </div>

            <div className="form-group row">
              <label className="col-sm-3 col-form-label">State</label>
              <div className="col-sm-5">
                <Select
                  name={`BillToState`}
                  isSearchable={true}
                  placeholder={'Please Select...'}
                  noOptionsMessage={() => 'No option'}
                  value={getLabel(this.state.addressObjForShop?.state, this.props.states)}
                  onChange={(e) => {
                    this.setState((prevState) => ({
                      addressObjForShop: {
                        ...prevState.addressObjForShop,
                        state: e.value,
                      },
                    }));
                  }}
                  className={'state_select'}
                  options={this.props.states}
                />
              </div>
              <label className="col-sm-2 col-form-label text-right">Zipcode</label>
              <div className="col-sm-2">
                <input
                  className={'form-control'}
                  autoComplete={'off'}
                  type={'text'}
                  name={`BillToZipcode`}
                  onChange={(e) => {
                    this.setState((prevState) => ({
                      addressObjForShop: {
                        ...prevState.addressObjForShop,
                        zip: e.target.value,
                      },
                    }));
                  }}
                  value={this.state.addressObjForShop?.zip || ''}
                />
              </div>
            </div>

            <div className="form-group row">
              <label className="col-sm-3 col-form-label">Country</label>
              <div className="col-sm-9">
                <Select
                  name={`BillToCountry`}
                  isSearchable={true}
                  placeholder={'Please Select...'}
                  noOptionsMessage={() => 'No option'}
                  value={getLabel(this.state.addressObjForShop?.country, this.props.countries)}
                  onChange={(e) => {
                    this.setState((prevState) => ({
                      addressObjForShop: {
                        ...prevState.addressObjForShop,
                        country: e.value,
                      },
                    }));
                  }}
                  className={'state_select'}
                  options={this.props.countries}
                />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-sm-3 col-form-label">Notes</label>
              <div className="col-sm-9">
                <textarea
                  className={'form-control'}
                  rows={3}
                  name={`Notes`}
                  placeholder="Optional notes..."
                  onChange={(e) => {
                    this.setState((prevState) => ({
                      addressObjForShop: {
                        ...prevState.addressObjForShop,
                        notes: e.target.value,
                      },
                    }));
                  }}
                  value={this.state.addressObjForShop?.notes || ''}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    // console.log('HomeKitPaymentFormModal STATE', this.state);
    // console.log('HomeKitPaymentFormModal PROPS', this.props);
    return (
      <React.Fragment>
        <Overlay show_loading={this.state.showLoading} zIndex={100005} />
        <div
          className="modal fade form_modal"
          id={HomeKitPaymentFormModal.ID}
          tabIndex={-1}
          role="dialog"
          aria-labelledby="result_modal_label"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-xl modal-lg" style={{ maxWidth: '768px' }} role="document">
            <div className="modal-content">
              <div className="modal-body p-0 m-0">
                <div className="container-fluid">
                  <div className={'row'}>
                    <div className="col-12 pt-2">
                      <div className="card mb-2">
                        <div className="card-header verlag-bold">
                          <div className="row">
                            <div className="col-10">
                              <h4>Payment Information</h4>
                            </div>
                            <div className="col-2">
                              <button
                                style={{ outline: 'none' }}
                                type="button"
                                className="close pr-4"
                                aria-label="Close"
                                onClick={() => {
                                  hideModal(HomeKitPaymentFormModal.ID);
                                }}
                              >
                                <span aria-hidden="true" style={{ fontSize: '1.5em', fontWeight: 'bold' }}>
                                  &times;
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="card-body">
                          <div className={'col-sm-12'}>
                            {/* Total */}
                            <div className="form-group row">
                              <label htmlFor={'totalAmountForServices'} className={'col-sm-4 col-form-label'}>
                                Total
                              </label>
                              <div className={'col-sm-8 m-0 input-group'}>
                                <div className="input-group-prepend">
                                  <span
                                    className="input-group-text text-dark"
                                    style={{ paddingLeft: '17.5px', paddingRight: '17.5px' }}
                                  >
                                    $
                                  </span>
                                </div>
                                <input
                                  type={'text'}
                                  id={'totalAmountForServices'}
                                  className="form-control"
                                  style={{ textAlign: 'right' }}
                                  value={
                                    this.state.cartTotal
                                      ? this.state.cartTotal.toLocaleString('en-US', {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })
                                      : this.state.totalAmountForServices
                                  }
                                  autoComplete="off"
                                  readOnly
                                />
                              </div>
                            </div>

                            {/* Recipient Address for Shop */}
                            <div className="form-group row text-center">
                              <label htmlFor={'recipientAddress'} className={'col-12 col-form-label'}>
                                Recipient Address
                              </label>
                            </div>
                            <div style={{ border: '1px solid lightgray', borderRadius: '1rem', padding: '1rem' }}>
                              {this.getShippingAddressForShop()}
                            </div>
                          </div>
                        </div>

                        {/* Payment Profile Option */}
                        <div className="card-footer" style={{ backgroundColor: 'transparent', borderTop: 'none' }}>
                          <div className="d-flex justify-content-around" style={{ gap: '3px' }}>
                            {this.displayPaymentProfileOptions()}

                            {!!this.state.hostedFormResponse && (
                              <div className="" id="entered_payment_options">
                                <div className={''}>Entered:</div>
                                <div className={'form-check'}>
                                  <input
                                    className={'form-check-input'}
                                    type="radio"
                                    name={'flexRadioGroup'}
                                    id={'flexRadioEntered'}
                                    onChange={() => {
                                      this.setState({ paymentObject: this.state.hostedFormResponse });
                                    }}
                                  />
                                  <label className={'form-check-label'} htmlFor={'flexRadioEntered'}>
                                    {this.state.hostedFormResponse?.encryptedCardData.cardNumber}
                                  </label>
                                </div>
                              </div>
                            )}
                            <div>
                              <div className={'col-sm-12'}>
                                <HostedForm
                                  authData={authData}
                                  onSubmit={(hostedFormResponse) => {
                                    this.handleHostedFormResponse(hostedFormResponse);
                                  }}
                                  environment={aNetEnv}
                                  billingAddressOptions={{ show: true, required: true }}
                                  buttonText={'Use Different Card'}
                                  formButtonText={`Confirm Card Information`}
                                  formHeaderText={`Payment for Products`}
                                  buttonClassName={'btn btn-primary'}
                                  paymentOptions={{ showCreditCard: true, showBankAccount: false }}
                                  buttonStyle={{}}
                                  errorTextStyle={{}}
                                  errorTextClassName={''}
                                  containerStyle={{}}
                                  containerClassName={''}
                                />
                                <div className={'text-center mt-2'}>
                                  <button
                                    className={'btn btn-success'}
                                    onClick={() => {
                                      if (
                                        this.state.paymentObject === null &&
                                        (this.state.paymentAmount != 0.0 || this.state.paymentAmount != 0)
                                      ) {
                                        return sweetalert.fire({
                                          icon: 'error',
                                          title: '',
                                          text: 'Please select a Payment Type.',
                                        });
                                      }
                                      if (this.state.showPaymentProfileInfo && !this.state.billToInfoVerified) {
                                        return sweetalert.fire({
                                          icon: 'error',
                                          title: '',
                                          text: 'Card Information cannot be saved without verifying billing information',
                                        });
                                      }
                                      if (!this.state.addressObjForShop) {
                                        this.setState({ shopValidated: false });
                                        return sweetalert.fire({
                                          icon: 'error',
                                          title: '',
                                          text: 'Recipient Information is required',
                                        });
                                      }

                                      if (
                                        !this.state.addressObjForShop.firstName ||
                                        this.state.addressObjForShop.firstName.trim() === ''
                                      ) {
                                        this.setState({ shopValidated: false });
                                        return sweetalert.fire({
                                          icon: 'error',
                                          title: '',
                                          text: 'Recipient First Name is required',
                                        });
                                      }

                                      if (
                                        !this.state.addressObjForShop.lastName ||
                                        this.state.addressObjForShop.lastName.trim() === ''
                                      ) {
                                        this.setState({ shopValidated: false });
                                        return sweetalert.fire({
                                          icon: 'error',
                                          title: '',
                                          text: 'Recipient Last Name is required',
                                        });
                                      }

                                      if (
                                        !this.state.addressObjForShop.email ||
                                        this.state.addressObjForShop.email.trim() === ''
                                      ) {
                                        this.setState({ shopValidated: false });
                                        return sweetalert.fire({
                                          icon: 'error',
                                          title: '',
                                          text: 'Facility Email is required',
                                        });
                                      }
                                      
                                      if (
                                        !this.state.addressObjForShop.phoneNumber ||
                                        this.state.addressObjForShop.phoneNumber.trim() === ''
                                      ) {
                                        this.setState({ shopValidated: false });
                                        return sweetalert.fire({
                                          icon: 'error',
                                          title: '',
                                          text: 'Recipient Phone is required',
                                        });
                                      }

                                      if (
                                        !this.state.addressObjForShop.address ||
                                        this.state.addressObjForShop.address.trim() === ''
                                      ) {
                                        this.setState({ shopValidated: false });
                                        return sweetalert.fire({
                                          icon: 'error',
                                          title: '',
                                          text: 'Recipient Address is required',
                                        });
                                      }

                                      if (
                                        !this.state.addressObjForShop.city ||
                                        this.state.addressObjForShop.city.trim() === ''
                                      ) {
                                        this.setState({ shopValidated: false });
                                        return sweetalert.fire({
                                          icon: 'error',
                                          title: '',
                                          text: 'Recipient City is required',
                                        });
                                      }

                                      if (!this.state.addressObjForShop.state) {
                                        this.setState({ shopValidated: false });
                                        return sweetalert.fire({
                                          icon: 'error',
                                          title: '',
                                          text: 'Recipient State is required',
                                        });
                                      }

                                      if (
                                        !this.state.addressObjForShop.zip ||
                                        this.state.addressObjForShop.zip.trim() === ''
                                      ) {
                                        this.setState({ shopValidated: false });
                                        return sweetalert.fire({
                                          icon: 'error',
                                          title: '',
                                          text: 'Recipient Zipcode is required',
                                        });
                                      }

                                      if (!this.state.addressObjForShop.country) {
                                        this.setState({ shopValidated: false });
                                        return sweetalert.fire({
                                          icon: 'error',
                                          title: '',
                                          text: 'Recipient Country is required',
                                        });
                                      }
                                      this.props.handleProductPaymentInfo(
                                        this.state.ANETCustomerProfile?.email ?? '',
                                        this.state.paymentObject,
                                        this.state.cartTotal.toLocaleString('en-US', {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        }),
                                        0,
                                        this.state.addressObjForShop,
                                        this.buildLineItems()
                                      );

                                      hideModal(HomeKitPaymentFormModal.ID);
                                      this.clearPaymentFormState();
                                    }}
                                    disabled={!this.state.hostedFormResponse && !this.state.ANETCustomerProfile}
                                  >
                                    Confirm
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
